<template>
  <div>
    <SelectTarget></SelectTarget>
    <div class="text-left">
      <div><b>Attendus</b> : Les coureurs qui sont attendus au point.</div>
      <div><b>Passés</b> : Les coureurs qui ont passé le point.</div>
      <div><b>A venir</b> : Les coureurs attendus qui n'ont pas passé le point.</div>
      <div><b>En retard</b> : Les coureurs qui sont en retard au point selon son heure de passage estimée.</div>
      <div><b>Sautés</b> : Les coureurs qui ont sauté le point. Ils n'ont pas de détection au point, mais ont passé un
        point ultérieur du parcours.</div>


    </div>
    <PassagesCourse class="my-3" v-if="$store.getters['pcCoursePassages/selectedType'] === 'course'"></PassagesCourse>
    <PassagesPoint class="my-3" v-if="$store.getters['pcCoursePassages/selectedType'] === 'point'"></PassagesPoint>
    <ExplicationsPassages class="mb-3"></ExplicationsPassages>

    <b-alert :show="$store.getters['pcCoursePassages/noTypeSelected']">
      Veuillez sélectionner une course ou un point.
    </b-alert>
    <!--  -->

    <!--  <b-container id="passages_pc_course" v-if="passages.list_parcours">
      <b-row>
        <b-col md="12">
          <div>
            <b-tabs content-class="mt-3">
              <b-tab title="Affichage par parcours" active>
                <p>Au départ d'une course, les partants passeront en coureurs attendus. Une ligne verte indique que tous
                  les coureurs attendus ont atteint le point de passage, une ligne rouge indique que des coureurs sont
                  encore attendus</p>
                <div v-for="(parcours, index) in passages.list_parcours.list" :key="index">
                  <SecuriteParcours :parcours="parcours"></SecuriteParcours>
                </div>
              </b-tab>
              <b-tab title="Affichage par point">
                <p>
                  Au départ d'une course, les statistiques de coureurs pour chacun des points du parcours seront
                  répercutées sur le point associé. Une ligne verte indique que tous les coureurs attendus sont passés
                  par
                  la box, une ligne rouge indique
                  que des coureurs sont encore attendus
                </p>

                <div v-for="(box, index_box) in passages.list_box" :key="index_box">
                  <SecuriteBox :box="box" :name="index_box"></SecuriteBox>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </b-col>
      </b-row>
    </b-container> -->
  </div>
</template>

<script>
import SecuriteParcours from "@/components/Live_tab/PCCourse/SecuriteParcours.vue";
import SecuriteBox from "@/components/Live_tab/PCCourse/SecuriteBox.vue";
import SelectTarget from "@/components/Live_tab/Passages/SelectTarget.vue";
import ExplicationsPassages from "@/components/Live_tab/Passages/ExplicationsPassages.vue";
import PassagesCourse from "@/components/Live_tab/Passages/PassagesCourse.vue";
import PassagesPoint from "@/components/Live_tab/Passages/PassagesPoint.vue";
export default {
  components: { SecuriteParcours, SecuriteBox, SelectTarget, ExplicationsPassages, PassagesCourse, PassagesPoint },
  data() {
    return {};
  },
  methods: {
    async refreshData() {
      const selectedType = this.$store.getters['pcCoursePassages/selectedType'];
      if (selectedType === 'course') {
        await this.$store.dispatch('pcCoursePassages/fetchCoursesPassages');
      } else if (selectedType === 'point') {
        await this.$store.dispatch('pcCoursePassages/fetchPointsPassages');
      }
    },
    countdownRefresh() {
      if (!this.$store.state.live_en_cours) {
        this.$store.commit("clearRefreshIntervals");
        return;
      }
      var _this = this;
      var intervalObject = setInterval(async function () {
        _this.$store.commit("clearRefreshIntervals");
        await _this.refreshData();
        _this.countdownRefresh();
      }, 5000);
      this.$store.state.refreshIntervals.push(intervalObject);
    },
  },
  created() {
    this.$store.commit("clearRefreshIntervals");
    this.countdownRefresh();
  },
};
</script>

<style lang="scss" scoped></style>